/* Capital Cookware theme — small progressive enhancements */
(function () {
  'use strict';

  // Quantity steppers
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-qty-change]');
    if (!btn) return;
    var wrap = btn.closest('.qty');
    var input = wrap && wrap.querySelector('input');
    if (!input) return;
    var step = parseInt(btn.getAttribute('data-qty-change'), 10) || 0;
    var min = parseInt(input.min, 10) || 1;
    var next = Math.max(min, (parseInt(input.value, 10) || min) + step);
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // Product gallery thumbnails
  document.addEventListener('click', function (event) {
    var thumb = event.target.closest('[data-gallery-thumb]');
    if (!thumb) return;
    var gallery = thumb.closest('[data-gallery]');
    var main = gallery && gallery.querySelector('[data-gallery-main]');
    if (!main) return;
    main.src = thumb.getAttribute('data-src');
    main.srcset = thumb.getAttribute('data-srcset') || '';
    main.alt = thumb.getAttribute('data-alt') || '';
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
      t.setAttribute('aria-current', t === thumb ? 'true' : 'false');
    });
  });

  // Variant picker: update price, stock, button state and URL
  document.querySelectorAll('[data-variant-select]').forEach(function (select) {
    var root = select.closest('[data-product]');
    var dataEl = root && root.querySelector('[data-variants-json]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    select.addEventListener('change', function () {
      var id = parseInt(select.value, 10);
      var v = variants.find(function (x) { return x.id === id; });
      if (!v) return;
      var price = root.querySelector('[data-price]');
      var compare = root.querySelector('[data-compare-price]');
      var stock = root.querySelector('[data-stock]');
      var addBtn = root.querySelector('[data-add-button]');
      if (price) price.textContent = v.price_formatted;
      if (compare) {
        if (v.compare_formatted) { compare.textContent = v.compare_formatted; compare.hidden = false; }
        else { compare.hidden = true; }
      }
      if (stock) {
        stock.className = 'stock info__stock ' + (v.available ? 'stock--in' : 'stock--out');
        stock.lastChild.textContent = v.available ? 'In stock' : 'Sold out';
      }
      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available ? 'Add to cart' : 'Sold out';
      }
      if (v.image) {
        var main = root.querySelector('[data-gallery-main]');
        if (main) { main.src = v.image; main.srcset = ''; }
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', id);
      window.history.replaceState({}, '', url.toString());
    });
  });

  // Collection sort
  document.querySelectorAll('[data-sort-select]').forEach(function (select) {
    select.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });

  // Product recommendations (loaded after page load)
  document.querySelectorAll('[data-recommendations-url]').forEach(function (el) {
    fetch(el.getAttribute('data-recommendations-url'))
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-recommendations-url]');
        if (fresh && fresh.innerHTML.trim().length) {
          el.innerHTML = fresh.innerHTML;
        } else {
          el.closest('.section') && (el.closest('.section').hidden = true);
        }
      })
      .catch(function () {});
  });

  // Hero video: pause/play button, and no autoplay for visitors who prefer reduced motion
  document.querySelectorAll('[data-hero-video]').forEach(function (wrap) {
    var video = wrap.querySelector('video');
    var btn = wrap.querySelector('[data-hero-video-toggle]');
    if (!video || !btn) return;
    function sync() {
      var paused = video.paused;
      wrap.classList.toggle('is-paused', paused);
      btn.setAttribute('aria-label', paused ? 'Play video' : 'Pause video');
    }
    video.addEventListener('play', sync);
    video.addEventListener('pause', sync);
    btn.addEventListener('click', function () {
      if (video.paused) { video.play(); } else { video.pause(); }
    });
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      video.removeAttribute('autoplay');
      video.pause();
    }
    sync();
  });

  // Announcement bar: rotate messages on small screens
  document.querySelectorAll('[data-announcement]').forEach(function (bar) {
    var items = bar.querySelectorAll('.announcement__item');
    if (items.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var i = 0;
    setInterval(function () {
      if (!window.matchMedia('(max-width: 749px)').matches) return;
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, 5000);
  });

  // Close the mobile drawer
  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-drawer-close]')) {
      var d = event.target.closest('details');
      if (d) d.removeAttribute('open');
    }
  });
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('details[open].drawer, .nav details[open]').forEach(function (d) { d.removeAttribute('open'); });
  });

  // Close desktop dropdowns when clicking elsewhere
  document.addEventListener('click', function (event) {
    document.querySelectorAll('.nav details[open]').forEach(function (d) {
      if (!d.contains(event.target)) d.removeAttribute('open');
    });
  });
})();
